export default [
  {
    id: "1",
    name: "Youth Fellowship",
    purpose: "Monthly youth contributions",
    createdAt: "2026-01-10T09:15:00.000Z",
    frequency: "monthly",
    members: [
      { name: "John Doe", phone: "0712345678", info: "Upper cluster" },
      { name: "Mary Wanjiku", phone: "0722123456", info: "Lower cluster" },
      { name: "Peter Otieno", phone: "0700111222", info: "East block" }
    ]
  },
  {
    id: "2",
    name: "Building Fund",
    purpose: "Hall renovation and repairs",
    createdAt: "2026-01-12T12:30:00.000Z",
    frequency: "monthly",
    members: [
      { name: "Alice Kamau", phone: "0798123456", info: "Phase 1" },
      { name: "Grace Njeri", phone: "0733444555", info: "Phase 2" }
    ]
  },
  {
    id: "3",
    name: "Welfare",
    purpose: "Emergency support for members",
    createdAt: "2026-01-15T18:05:00.000Z",
    frequency: "weekly",
    members: [
      { name: "Samuel Kiptoo", phone: "0711002200", info: "North zone" },
      { name: "Rose Atieno", phone: "0722333444", info: "West zone" },
      { name: "James Mwangi", phone: "0744555666", info: "South zone" }
    ]
  }
];
